import { InjectionToken } from '@angular/core';
import { environment } from '../../../environments/environment';
import * as i0 from "@angular/core";
export function moduleConfigFunc() {
    return new InjectionToken('');
}
var ModuleConfigService = /** @class */ (function () {
    function ModuleConfigService(moduleConfigVal) {
        if (moduleConfigVal === void 0) { moduleConfigVal = null; }
        // console.log('module config inject', moduleConfigVal());
        this._config = moduleConfigVal() ||
            {
                ApiFileUpload: environment.apiDomain.fileEndpoint + "/upload"
            };
    }
    ModuleConfigService.prototype.getConfig = function () {
        return this._config;
    };
    ModuleConfigService.ngInjectableDef = i0.defineInjectable({ factory: function ModuleConfigService_Factory() { return new ModuleConfigService(i0.inject(moduleConfigFunc, 8)); }, token: ModuleConfigService, providedIn: "root" });
    return ModuleConfigService;
}());
export { ModuleConfigService };
